import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  DataTable,
  EmptyState,
  Error,
  Loading,
  Pagination,
} from "@rentiohq/web-shared/dist/components";
import { ts } from "../../../../services";
import { IDocumentsListProps } from "./DocumentList.types";

const SORTABLE_COLUMN_INDEX = 2;

export const DocumentsList = (props: IDocumentsListProps) => {
  const {
    emptyStateTitle,
    rows,
    page,
    totalPages,
    isLoadingData,
    isFetching,
    fetchError,
    handlePageClick,
    handleRowClick,
    sortMethod,
    handleSort,
  } = props;

  // Render methods
  const renderPaging = () => {
    if (totalPages <= 1) {
      return;
    }

    return (
      <Pagination
        initialPage={page - 1}
        pageCount={totalPages}
        onPageChange={({ selected }: { selected: number }) => {
          handlePageClick(selected);
        }}
      />
    );
  };

  if (fetchError) {
    return (
      <>
        <Error errors={[fetchError]} />
        {renderPaging()}
      </>
    );
  }

  if (isFetching) {
    return (
      <>
        <Loading />
        {renderPaging()}
      </>
    );
  }

  return (
    <>
      <DataTable
        columnContentTypes={["text", "text", "text", "text", "action"]}
        headings={[
          ts.system("name"),
          getLocalizedText("system.contract"),
          ts.uploadDate(),
          ts.propertyDocumentsSharedWithTitle(),
          "",
        ]}
        emptyState={
          <EmptyState backgroundColor="gray" heading={emptyStateTitle} />
        }
        rows={rows}
        sortable={[false, false, true, false, false]}
        sortColumnIndex={SORTABLE_COLUMN_INDEX}
        sortDirection={sortMethod}
        onSort={handleSort}
        isLoadingData={isLoadingData}
        asDots={true}
        onRowClick={handleRowClick}
      />
      {renderPaging()}
    </>
  );
};
